module.exports = __webpack_public_path__ + "static/media/admin.f78d61c8.svg";